import { defineAsyncComponent } from 'vue';

const IconComplexAudience = defineAsyncComponent(() => import('./Audience.vue'));
const IconComplexAudienceFile = defineAsyncComponent(() => import('./AudienceFile.vue'));
const IconComplexAudienceGeofenceGroup = defineAsyncComponent(() => import('./AudienceGeofenceGroup.vue'));
const IconComplexAudienceLogic = defineAsyncComponent(() => import('./AudienceLogic.vue'));
// const IconComplexCampaign = defineAsyncComponent(() => import('./Campaign.vue'));
const IconComplexAvails = defineAsyncComponent(() => import('./Avails.vue'));
const IconComplexCampaign2 = defineAsyncComponent(() => import('./Campaign2.vue'));
const IconComplexCheck = defineAsyncComponent(() => import('./Check.vue'));
const IconComplexCreative = defineAsyncComponent(() => import('./Creative.vue'));
const IconComplexCreative2 = defineAsyncComponent(() => import('./Creative2.vue'));
const IconComplexCreativeFile2 = defineAsyncComponent(() => import('./CreativeFile2.vue'));
const IconComplexCustomField = defineAsyncComponent(() => import('./CustomField.vue'));
const IconComplexDeal = defineAsyncComponent(() => import('./Deal.vue'));
const IconComplexDeal2 = defineAsyncComponent(() => import('./Deal2.vue'));
const IconComplexDone = defineAsyncComponent(() => import('./Done.vue'));
const IconComplexExternalCreative = defineAsyncComponent(() => import('./ExternalCreative.vue'));
const IconComplexExternalEvent = defineAsyncComponent(() => import('./ExternalEvent.vue'));
const IconComplexFlight = defineAsyncComponent(() => import('./Flight.vue'));
const IconComplexForbidden = defineAsyncComponent(() => import('./Forbidden.vue'));
const IconComplexGeofenceGroup = defineAsyncComponent(() => import('./GeofenceGroup.vue'));
const IconComplexJourney = defineAsyncComponent(() => import('./Journey.vue'));
const IconComplexLiftDashboard = defineAsyncComponent(() => import('./LiftDashboard.vue'));
const IconComplexLightBulb = defineAsyncComponent(() => import('./LightBulb.vue'));
const IconComplexLineItem2 = defineAsyncComponent(() => import('./LineItem2.vue'));
const IconComplexMap = defineAsyncComponent(() => import('./Map.vue'));
const IconComplexMobilePhone = defineAsyncComponent(() => import('./MobilePhone.vue'));
const IconComplexNetwork = defineAsyncComponent(() => import('./Network.vue'));
const IconComplexPlan = defineAsyncComponent(() => import('./Plan.vue'));
const IconComplexPostalCode = defineAsyncComponent(() => import('./PostalCode.vue'));
const IconComplexPreSaleHeatmap = defineAsyncComponent(() => import('./PreSaleHeatmap.vue'));
const IconComplexReport = defineAsyncComponent(() => import('./Report.vue'));
const IconComplexReport2 = defineAsyncComponent(() => import('./Report2.vue'));
const IconComplexRule = defineAsyncComponent(() => import('./Rule.vue'));
const IconComplexSad = defineAsyncComponent(() => import('./Sad.vue'));
const IconComplexScreenPack = defineAsyncComponent(() => import('./ScreenPack.vue'));
const IconComplexSite = defineAsyncComponent(() => import('./Site.vue'));
const IconComplexSSP = defineAsyncComponent(() => import('./SSP.vue'));
const IconComplexTarget = defineAsyncComponent(() => import('./Target.vue'));
const IconComplexTime = defineAsyncComponent(() => import('./Time.vue'));
const IconComplexUnit = defineAsyncComponent(() => import('./Unit.vue'));
const IconComplexUpload = defineAsyncComponent(() => import('./Upload.vue'));

export {
  IconComplexAudience,
  IconComplexAudienceFile,
  IconComplexAudienceGeofenceGroup,
  IconComplexAudienceLogic,
  IconComplexAvails,
  // IconComplexCampaign,
  IconComplexCampaign2,
  IconComplexCheck,
  IconComplexCreative,
  IconComplexCreative2,
  IconComplexCreativeFile2,
  IconComplexCustomField,
  IconComplexDeal,
  IconComplexDeal2,
  IconComplexDone,
  IconComplexExternalCreative,
  IconComplexExternalEvent,
  IconComplexFlight,
  IconComplexForbidden,
  IconComplexGeofenceGroup,
  IconComplexJourney,
  IconComplexLiftDashboard,
  IconComplexLightBulb,
  IconComplexLineItem2,
  IconComplexMap,
  IconComplexMobilePhone,
  IconComplexNetwork,
  IconComplexPlan,
  IconComplexPostalCode,
  IconComplexPreSaleHeatmap,
  IconComplexReport,
  IconComplexReport2,
  IconComplexRule,
  IconComplexSad,
  IconComplexScreenPack,
  IconComplexSite,
  IconComplexSSP,
  IconComplexTarget,
  IconComplexTime,
  IconComplexUnit,
  IconComplexUpload,
};

export default {};
